import constants from '#packages/constants';
import addPanelDataConsts from '#packages/addPanelDataConsts';

const { COMP_TYPES } = constants;

export const AUTOMATION_IDS = {
  DEPRECATION_OVERLAY: 'deprecated-component-overlay',
};

export const PANEL_NAME = 'deprecationOverlay.panels.deprecatedComponentPanel';

export const DEPRECATED_COMPONENTS_DATA = {
  [COMP_TYPES.HOVER_BOX]: {
    MODAL_ACTIONS: {
      ADD_PANEL: {
        CATEGORY: addPanelDataConsts.CATEGORIES_ID.BOX,
        SECTION: 'interactionsHoverSection',
      },
    },
    TRANSLATIONS: {
      BANNER: {
        TEXT: 'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_BANNER_TEXT',
        CTA: 'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_BANNER_CTA',
      },
      MODAL: {
        TITLE: 'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_MODAL_TITLE',
        BODY: 'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_MODAL_BODY',
        MAIN_BUTTON: 'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_MODAL_MAIN_CTA',
        SECONDARY_BUTTON:
          'ONSTAGE_POPUP_HOVERBOX_DEPRECATING_MODAL_SECONDARY_CTA',
      },
    },
  },
};
